module.exports = __webpack_public_path__ + "static/media/5.652fc578.svg";